import { createFileRoute, Navigate } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import Layout from "@/components/layout/Layout";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { isFeatureEnabled } from "@/services/core/feature-flags.service";

const VRPlayground = lazy(() => import("@/pages/VRPlayground"));

export const Route = createFileRoute("/vr-playground/")({
  component: VRPlaygroundRoute,
});

function VRPlaygroundRoute() {
  if (!isFeatureEnabled("vr_playground")) {
    return <Navigate to="/" replace />;
  }
  return (
    <ProtectedRoute>
      <Layout>
        <Suspense fallback={null}>
          <VRPlayground />
        </Suspense>
      </Layout>
    </ProtectedRoute>
  );
}
